import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID,
    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_ID,

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE,

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE,

    ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE,

    ITrialInstitutionLaboratoryFinanceLoadByTrialInstitutionLaboratoryIdAction,
    ITrialInstitutionLaboratoryFinanceLoadByIdAction,
    ITrialInstitutionLaboratoryFinanceLoadFailureAction,
    ITrialInstitutionLaboratoryFinanceLoadSuccessAction,

    ITrialInstitutionLaboratoryFinanceSaveAction,
    ITrialInstitutionLaboratoryFinanceSaveSuccessAction,
    ITrialInstitutionLaboratoryFinanceSaveFailureAction,

    ITrialInstitutionLaboratoryFinanceCreateAction,
    ITrialInstitutionLaboratoryFinanceCreateSuccessAction,
    ITrialInstitutionLaboratoryFinanceCreateFailureAction,

    ITrialInstitutionLaboratoryFinanceValidateAction,
    ITrialInstitutionLaboratoryFinanceValidateSuccessAction,
    ITrialInstitutionLaboratoryFinanceValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialInstitutionLaboratoryFinance";
import { trialInstitutionLaboratoryFinanceApi } from "../services/trialInstitutionLaboratoryFinance";

export const
    getTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryIdEpic = (action$): Observable<ITrialInstitutionLaboratoryFinanceLoadSuccessAction | ITrialInstitutionLaboratoryFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID)
            .mergeMap((action: ITrialInstitutionLaboratoryFinanceLoadByTrialInstitutionLaboratoryIdAction) => {
                return trialInstitutionLaboratoryFinanceApi
                    .getTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryId(action.trialInstitutionLaboratoryId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratoryFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionLaboratoryFinanceByIdEpic = (action$): Observable<ITrialInstitutionLaboratoryFinanceLoadSuccessAction | ITrialInstitutionLaboratoryFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYFINANCE_LOAD_BY_ID)
            .mergeMap((action: ITrialInstitutionLaboratoryFinanceLoadByIdAction) => {
                return trialInstitutionLaboratoryFinanceApi
                    .getTrialInstitutionLaboratoryFinanceById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratoryFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialInstitutionLaboratoryFinanceEpic = (action$): Observable<ITrialInstitutionLaboratoryFinanceSaveSuccessAction | ITrialInstitutionLaboratoryFinanceSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYFINANCE_SAVE)
            .mergeMap((action: ITrialInstitutionLaboratoryFinanceSaveAction) => {
                return trialInstitutionLaboratoryFinanceApi
                    .setTrialInstitutionLaboratoryFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialInstitutionLaboratoryFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialInstitutionLaboratoryFinanceEpic = (action$): Observable<ITrialInstitutionLaboratoryFinanceCreateSuccessAction | ITrialInstitutionLaboratoryFinanceCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYFINANCE_CREATE)
            .mergeMap((action: ITrialInstitutionLaboratoryFinanceCreateAction) => {
                return trialInstitutionLaboratoryFinanceApi
                    .createTrialInstitutionLaboratoryFinance(action.trialInstitutionLaboratoryId)
                    .map(response =>
                        CreateSuccess(
                            response.trialInstitutionLaboratoryFinance,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialInstitutionLaboratoryFinanceEpic = (action$): Observable<ITrialInstitutionLaboratoryFinanceValidateSuccessAction | ITrialInstitutionLaboratoryFinanceValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYFINANCE_VALIDATE)
            .mergeMap((action: ITrialInstitutionLaboratoryFinanceValidateAction) => {
                return trialInstitutionLaboratoryFinanceApi
                    .validateTrialInstitutionLaboratoryFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialInstitutionLaboratoryFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }